var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillingStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "#EFF5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3411_10036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3362 15.9182L17.6882 22.5661L15.6637 20.5416C15.3848 20.2627 14.9325 20.2627 14.6536 20.5416C14.3746 20.8206 14.3746 21.2728 14.6536 21.5518L17.1832 24.0814C17.3226 24.2209 17.5054 24.2906 17.6882 24.2906C17.871 24.2906 18.0539 24.2208 18.1933 24.0814L25.3463 16.9283C25.6253 16.6493 25.6253 16.1971 25.3463 15.9181C25.0675 15.6393 24.6151 15.6393 24.3362 15.9182Z",
    fill: "#99A4A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10C14.486 10 10 14.486 10 20C10 25.514 14.486 30 20 30C25.514 30 30 25.514 30 20C30 14.486 25.514 10 20 10ZM20 28.5714C15.2737 28.5714 11.4286 24.7263 11.4286 20C11.4286 15.2737 15.2737 11.4286 20 11.4286C24.7263 11.4286 28.5714 15.2737 28.5714 20C28.5714 24.7263 24.7263 28.5714 20 28.5714Z",
    fill: "#99A4A3"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "#E9F1F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3411_10036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingStatus);
export default __webpack_public_path__ + "static/media/billingStatus.fbea36ac59a9d5368b921139f93f2929.svg";
export { ForwardRef as ReactComponent };